import AssetEventsTable from '@/matter-asset-common/events/AssetEventsTable'
import { MedChronEventsTableVariant } from './med-chron-events-table-variant'

interface MedChronEventsTableProps {
  variant: MedChronEventsTableVariant
}

/**
 * Medical Chronology Events Table
 *
 * Thin wrapper over the shared AssetEventsTable. The med-chron data wiring, columns, copy, and
 * retry behavior come from `medChronFeatureConfig` supplied by the asset shell's
 * MatterAssetFeatureProvider; this wrapper only forwards the display variant:
 * - All Events: Shows base information for each event
 * - Detailed View: Shows all available information for each event
 */
export default function MedChronEventsTable(props: MedChronEventsTableProps) {
  const { variant } = props
  return <AssetEventsTable variant={variant} />
}
